import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { COLORS, INITIATIVE_STATUS_COLORS, STATUS_COLORS } from '../constants/config';

import { tokens } from '@design';
type BadgeVariant = 'success' | 'warning' | 'danger' | 'info' | 'primary' | 'secondary' | 'default';
type InitiativeStatus = 'planning' | 'in_progress' | 'completed' | 'on_hold' | 'cancelled';

interface BadgeProps {
  text: string;
  variant?: BadgeVariant;
  status?: InitiativeStatus;
  size?: 'small' | 'medium' | 'large';
}

export default function Badge({ text, variant = 'default', status, size = 'medium' }: BadgeProps) {
  const getBackgroundColor = () => {
    if (status) {
      return INITIATIVE_STATUS_COLORS[status] || COLORS.gray;
    }

    switch (variant) {
      case 'success':
        return COLORS.success;
      case 'warning':
        return COLORS.warning;
      case 'danger':
        return COLORS.danger;
      case 'info':
        return COLORS.info;
      case 'primary':
        return COLORS.primary;
      case 'secondary':
        return COLORS.secondary;
      default:
        return COLORS.gray;
    }
  };

  const getTextColor = () => {
    if (variant === 'warning') return COLORS.dark;
    return COLORS.white;
  };

  const sizeStyles = {
    small: { paddingHorizontal: tokens.spacing.absolute["1_5"], paddingVertical: tokens.spacing.absolute["0_5"], fontSize: 10 },
    medium: { paddingHorizontal: tokens.spacing.absolute["2_5"], paddingVertical: tokens.spacing.absolute["1"], fontSize: tokens.typography.paragraph["paragraph mini font size"] },
    large: { paddingHorizontal: tokens.spacing.absolute["3_5"], paddingVertical: tokens.spacing.absolute["1_5"], fontSize: tokens.typography.paragraph["paragraph small font size"] },
  };

  return (
    <View
      style={[
        styles.badge,
        {
          backgroundColor: getBackgroundColor(),
          paddingHorizontal: sizeStyles[size].paddingHorizontal,
          paddingVertical: sizeStyles[size].paddingVertical,
        },
      ]}
    >
      <Text
        style={[
          styles.text,
          { color: getTextColor(), fontSize: sizeStyles[size].fontSize },
        ]}
      >
        {text}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  badge: {
    borderRadius: tokens.radii.absolute["radius-20"],
    alignSelf: 'flex-start',
  },
  text: {
    fontWeight: '600',
    textAlign: 'center',
  },
});
